import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { RadioQuestionModel } from '../../../viewmodels/policy-item.model';
import { OtherCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'other-policy',
  templateUrl: './other.component.html',
})
export class OtherComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = OtherCopy;

  denyPcn = new RadioQuestionModel();
  denyNoticeOwner = new RadioQuestionModel();
  privateProperty = new RadioQuestionModel();
  writesAfter = new RadioQuestionModel();
  companyContact = new RadioQuestionModel();
  legislation = new RadioQuestionModel();
  civilOfficer = new RadioQuestionModel();
  payDisplayTicket = new RadioQuestionModel();
  parkingTicket = new RadioQuestionModel();
  postalPcns = new RadioQuestionModel();
  issuedPcn = new RadioQuestionModel();
  officerWatched = new RadioQuestionModel();
  photographicEvidence = new RadioQuestionModel();
  personKeeper = new RadioQuestionModel();
  contraventionExplanation = new RadioQuestionModel();
  dontUnderstand = new RadioQuestionModel();
  noticeOfRejection = new RadioQuestionModel();
  adjudicatorInformation = new RadioQuestionModel();
  customiseColour = new RadioQuestionModel();
  discountedRate = new RadioQuestionModel();
  clickableLink = new RadioQuestionModel();

  company: {
    name: string;
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    postcode: string;
    telephone: string;
  };
  enforcementAgents: string;
  parkingAttendant: string;
  photographicEvidenceOnline: string;
  cctvEvidenceOnline: string;

  parkingAreas: Array<{
    id: number;
    data: any;
    valueSelected: any;
  }> = [];

  legislations: {
    example: string;
    busLane: string;
    moving: string;
    parking: string;
  };

  explainContraventionStages: Array<{
    id: number;
    data: any;
    valueSelected: any;
  }> = [];

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setDenyPcnQuestion();
    this.setDenyNoticeOwnerQuestion();
    this.setPrivatePropertyQuestion();
    this.setWritesAfterQuestion();
    this.setCompanyContactQuestion();
    this.setLegislationQuestion();
    this.setCivilOfficerQuestion();
    this.setPayDisplayTicketQuestion();
    this.setParkingTicketQuestion();
    this.setPostalPcnsQuestion();
    this.setIssuedPcnQuestion();
    this.setOfficerWatchedQuestion();
    this.setPhotographicEvidenceQuestion();
    this.setPersonKeeperQuestion();
    this.setParkingAreasQuestions();
    this.setContraventionExplanationQuestion();
    this.setDontUnderstandQuestion();
    this.setNoticeOfRejectionQuestion();
    this.setAdjudicatorInformationQuestion();
    this.setExplainContraventionStagesQuestions();
    this.setCustomiseColourQuestion();
    this.setDiscountedRateQuestion();
    this.setClickableLinkQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setDenyPcnQuestion() {
    this.denyPcn.data = {
      title: this.textCopy.other_1,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
  }

  setDenyNoticeOwnerQuestion() {
    this.denyNoticeOwner.data = {
      title: this.textCopy.other_2,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
  }

  setPrivatePropertyQuestion() {
    this.privateProperty.data = {
      title: this.textCopy.other_3,
      includeTitle: true,
      answers: [
        { text: 'check site', value: '0' },
        { text: 'check map/records', value: '1' },
        { text: 'check map/records first, then check site if necessary', value: '2' },
      ],
    };
  }

  setWritesAfterQuestion() {
    this.writesAfter.data = {
      title: this.textCopy.other_4,
      includeTitle: true,
      answers: [
        { text: 'tell the driver to contact the bailiffs/enforcement agents/sheriffs', value: '0' },
        {
          text: `forward the driver's letter to the bailiffs/enforcement agents/sheriffs and let the driver know`,
          value: '1',
        },
      ],
    };
  }

  setCompanyContactQuestion() {
    this.companyContact.data = {
      title: this.textCopy.other_5,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }

  setLegislationQuestion() {
    this.legislation.data = {
      title: this.textCopy.other_6,
      includeTitle: true,
      answers: [
        { text: `TMA 2004`, value: '0' },
        { text: `RTA 1991`, value: '1' },
        { text: `Neither of the above`, value: '2' },
      ],
    };
  }

  setCivilOfficerQuestion() {
    this.civilOfficer.data = {
      title: this.textCopy.other_7_5,
      answers: [
        { text: `'civil enforcement officer'`, value: '0' },
        { text: `'Civil Enforcement Officer'`, value: '1' },
        { text: `'CEO'`, value: '2' },
        { text: `'Civil Enforcement Officer (CEO)' initially then 'CEO' after that`, value: '3' },
      ],
    };
  }

  setPayDisplayTicketQuestion() {
    this.payDisplayTicket.data = {
      title: this.textCopy.other_7_6,
      answers: [
        { text: `Pay & Display ticket`, value: '0' },
        { text: `Pay and Display ticket`, value: '1' },
        { text: `pay & display ticket`, value: '2' },
        { text: `pay and display ticket`, value: '3' },
      ],
    };
  }

  setParkingTicketQuestion() {
    this.parkingTicket.data = {
      title: this.textCopy.other_7_7,
      answers: [
        { text: `'parking ticket'`, value: '0' },
        { text: `'Penalty Charge Notice'`, value: '1' },
        { text: `'PCN'`, value: '2' },
        { text: `'Penalty Charge Notice (PCN)' initially then 'PCN' after that`, value: '3' },
      ],
    };
  }

  setPostalPcnsQuestion() {
    this.postalPcns.data = {
      title: this.textCopy.other_7_8,
      answers: [
        { text: `'Penalty Charge Notice'`, value: '0' },
        { text: `'PCN'`, value: '1' },
        { text: `'Penalty Charge Notice (PCN)' initially then 'PCN' after that`, value: '2' },
      ],
    };
  }

  setIssuedPcnQuestion() {
    this.issuedPcn.data = {
      title: this.textCopy.other_7_9,
      answers: [
        { text: `'given' (easier for people to understand)`, value: '0' },
        { text: `'issued'`, value: '1' },
      ],
    };
  }

  setOfficerWatchedQuestion() {
    this.officerWatched.data = {
      title: this.textCopy.other_7_10,
      answers: [
        { text: `'watched' (easier for people to understand)`, value: '0' },
        { text: `'observed'`, value: '1' },
      ],
    };
  }

  setPhotographicEvidenceQuestion() {
    this.photographicEvidence.data = {
      title: this.textCopy.other_7_11,
      answers: [
        { text: `enclose photos`, value: '0' },
        {
          text: `quote a website address and advise the driver to look at photographic evidence online`,
          value: '1',
        },
        { text: `do either of the above, depending on the case`, value: '2' },
      ],
    };
  }

  setPersonKeeperQuestion() {
    this.personKeeper.data = {
      title: this.textCopy.other_7_14,
      answers: [
        { text: `yes`, value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }

  setParkingAreasQuestions() {
    const defaultAnswers = [
      { text: `yes`, value: 'y' },
      { text: `no`, value: 'n' },
      { text: `sometimes – ask the user each time`, value: 'q' },
    ];
    this.parkingAreas = [
      {
        id: 1,
        data: {
          title: this.textCopy.other_8_1,
          includeTitle: true,
          answers: [
            { text: `London`, value: '2' },
            { text: `Scotland`, value: '1' },
            { text: `Elsewhere in the UK`, value: '0' },
          ],
        },
        valueSelected: '2',
      },
      {
        id: 2,
        data: {
          title: this.textCopy.other_8_2,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
      {
        id: 3,
        data: {
          title: this.textCopy.other_8_3,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
      {
        id: 4,
        data: {
          title: this.textCopy.other_8_4,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
      {
        id: 5,
        data: {
          title: this.textCopy.other_8_5,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
    ];
  }
  onParkingAreaSelect(answerValue, parkingAreaId) {
    this.parkingAreas[parkingAreaId - 1].valueSelected = answerValue;
  }

  setContraventionExplanationQuestion() {
    this.contraventionExplanation.data = {
      title: this.textCopy.other_10_1,
      includeTitle: true,
      answers: [
        { text: `yes`, value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }

  setDontUnderstandQuestion() {
    this.dontUnderstand.data = {
      title: this.textCopy.other_10_2,
      answers: [
        { text: `yes`, value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }

  setNoticeOfRejectionQuestion() {
    this.noticeOfRejection.data = {
      title: this.textCopy.other_11,
      includeTitle: true,
      answers: [
        { text: `yes`, value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }

  setAdjudicatorInformationQuestion() {
    this.adjudicatorInformation.data = {
      title: this.textCopy.other_12,
      includeTitle: true,
      answers: [
        { text: `yes`, value: 'y' },
        { text: `no`, value: 'n' },
        { text: `sometimes – ask the user each time`, value: 'q' },
      ],
    };
  }

  setExplainContraventionStagesQuestions() {
    const defaultAnswers = [
      { text: `yes`, value: 'y' },
      { text: `no`, value: 'n' },
    ];
    this.explainContraventionStages = [
      {
        id: 1,
        data: {
          title: this.textCopy.other_13,
          includeTitle: true,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
      {
        id: 2,
        data: {
          title: this.textCopy.other_13_2,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
      {
        id: 3,
        data: {
          title: this.textCopy.other_13_3,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
      {
        id: 4,
        data: {
          title: this.textCopy.other_13_4,
          answers: defaultAnswers,
        },
        valueSelected: 'n',
      },
    ];
  }
  onExplainContraventionStagesSelect(answerValue, stageId) {
    this.explainContraventionStages[stageId - 1].valueSelected = answerValue;
  }

  setCustomiseColourQuestion() {
    this.customiseColour.data = {
      title: this.textCopy.other_14,
      includeTitle: true,
      answers: [
        { text: `purple`, value: '0' },
        { text: `red`, value: '1' },
      ],
    };
  }

  setDiscountedRateQuestion() {
    this.discountedRate.data = {
      title: this.textCopy.other_15,
      includeTitle: true,
      answers: [
        { text: `yes`, value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }

  setClickableLinkQuestion() {
    this.clickableLink.data = {
      title: this.textCopy.other_16,
      includeTitle: true,
      answers: [
        { text: `yes`, value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }

  onRadioSelected(answer, object) {
    object.valueSelected = answer;
  }

  setSelectedValues() {
    this.company = {
      name: this.policiesAnswers['22_7_1'],
      address1: this.policiesAnswers['22_7_2'],
      address2: this.policiesAnswers['22_7_3'],
      address3: this.policiesAnswers['22_7_4'],
      address4: this.policiesAnswers['22_7_5'],
      postcode: this.policiesAnswers['22_7_6'],
      telephone: this.policiesAnswers['22_7_7'],
    };
    this.enforcementAgents = this.policiesAnswers['22_18'];
    this.parkingAttendant = this.policiesAnswers['22_14'];
    this.photographicEvidenceOnline = this.policiesAnswers['22_14_7'];
    this.cctvEvidenceOnline = this.policiesAnswers['22_26_7'];
    this.legislations = {
      example: this.policiesAnswers['22_10_3'],
      busLane: this.policiesAnswers['22_10_1'],
      moving: this.policiesAnswers['22_10_2'],
      parking: this.policiesAnswers['22_10_3'],
    };

    this.denyPcn.valueSelected = this.policiesAnswers['22_8'];
    this.denyNoticeOwner.valueSelected = this.policiesAnswers['22_1'];
    this.privateProperty.valueSelected = this.policiesAnswers['22_4'];
    this.writesAfter.valueSelected = this.policiesAnswers['22_5'];
    this.companyContact.valueSelected = this.policiesAnswers['22_7'];
    this.legislation.valueSelected = this.policiesAnswers['22_12'];
    this.civilOfficer.valueSelected = this.policiesAnswers['22_14_1'];
    this.payDisplayTicket.valueSelected = this.policiesAnswers['22_14_2'];
    this.parkingTicket.valueSelected = this.policiesAnswers['22_14_3'];
    this.postalPcns.valueSelected = this.policiesAnswers['22_14_8'];
    this.issuedPcn.valueSelected = this.policiesAnswers['22_14_4'];
    this.officerWatched.valueSelected = this.policiesAnswers['22_14_5'];
    this.photographicEvidence.valueSelected = this.policiesAnswers['22_14_6'];
    this.personKeeper.valueSelected = this.policiesAnswers['22_24'];
    this.contraventionExplanation.valueSelected = this.policiesAnswers['22_11'];
    this.dontUnderstand.valueSelected = this.policiesAnswers['22_11_1'];
    this.noticeOfRejection.valueSelected = this.policiesAnswers['22_13'];
    this.adjudicatorInformation.valueSelected = this.policiesAnswers['22_20'];
    this.customiseColour.valueSelected = this.policiesAnswers['22_17'];
    this.discountedRate.valueSelected = this.policiesAnswers['22_23'];
    this.clickableLink.valueSelected = this.policiesAnswers['22_25'];

    this.explainContraventionStages[0].valueSelected = this.policiesAnswers['22_15_1'];
    this.explainContraventionStages[1].valueSelected = this.policiesAnswers['22_15_2'];
    this.explainContraventionStages[2].valueSelected = this.policiesAnswers['22_15_3'];
    this.explainContraventionStages[3].valueSelected = this.policiesAnswers['22_27'];

    this.setSelectedParkingAreasQuestions();
  }

  setSelectedParkingAreasQuestions() {
    const selectedAnswers = [
      { id: 1, value: this.policiesAnswers['22_9'] },
      { id: 2, value: this.policiesAnswers['22_16'] },
      { id: 3, value: this.policiesAnswers['22_19'] },
      { id: 4, value: this.policiesAnswers['22_21'] },
      { id: 5, value: this.policiesAnswers['22_22'] },
    ];
    this.parkingAreas.forEach((parkingArea) => {
      selectedAnswers.forEach((selectedAnswer) => {
        if (parkingArea.id === selectedAnswer.id) {
          parkingArea.valueSelected = selectedAnswer.value;
        }
      });
    });
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '22_7_1', description: this.company.name },
      { id: '22_7_2', description: this.company.address1 },
      { id: '22_7_3', description: this.company.address2 },
      { id: '22_7_4', description: this.company.address3 },
      { id: '22_7_5', description: this.company.address4 },
      { id: '22_7_6', description: this.company.postcode },
      { id: '22_7_7', description: this.company.telephone },
      { id: '22_18', description: this.enforcementAgents },
      { id: '22_14', description: this.parkingAttendant },
      { id: '22_14_7', description: this.photographicEvidenceOnline },
      { id: '22_26_7', description: this.cctvEvidenceOnline },
      { id: '22_10_1', description: this.legislations.busLane },
      { id: '22_10_2', description: this.legislations.moving },
      { id: '22_10_3', description: this.legislations.parking },
      { id: '22_8', description: this.denyPcn.valueSelected },
      { id: '22_1', description: this.denyNoticeOwner.valueSelected },
      { id: '22_4', description: this.privateProperty.valueSelected },
      { id: '22_5', description: this.writesAfter.valueSelected },
      { id: '22_7', description: this.companyContact.valueSelected },
      { id: '22_12', description: this.legislation.valueSelected },
      { id: '22_14_1', description: this.civilOfficer.valueSelected },
      { id: '22_14_2', description: this.payDisplayTicket.valueSelected },
      { id: '22_14_3', description: this.parkingTicket.valueSelected },
      { id: '22_14_8', description: this.postalPcns.valueSelected },
      { id: '22_14_4', description: this.issuedPcn.valueSelected },
      { id: '22_14_5', description: this.officerWatched.valueSelected },
      { id: '22_14_6', description: this.photographicEvidence.valueSelected },
      { id: '22_24', description: this.personKeeper.valueSelected },
      { id: '22_11', description: this.contraventionExplanation.valueSelected },
      { id: '22_11_1', description: this.dontUnderstand.valueSelected },
      { id: '22_13', description: this.noticeOfRejection.valueSelected },
      { id: '22_20', description: this.adjudicatorInformation.valueSelected },
      { id: '22_17', description: this.customiseColour.valueSelected },
      { id: '22_23', description: this.discountedRate.valueSelected },
      { id: '22_25', description: this.clickableLink.valueSelected },
      { id: '22_15_1', description: this.explainContraventionStages[0].valueSelected },
      { id: '22_15_2', description: this.explainContraventionStages[1].valueSelected },
      { id: '22_15_3', description: this.explainContraventionStages[2].valueSelected },
      { id: '22_27', description: this.explainContraventionStages[3].valueSelected },
      { id: '22_9', description: this.parkingAreas[0].valueSelected },
      { id: '22_16', description: this.parkingAreas[1].valueSelected },
      { id: '22_19', description: this.parkingAreas[2].valueSelected },
      { id: '22_21', description: this.parkingAreas[3].valueSelected },
      { id: '22_22', description: this.parkingAreas[4].valueSelected },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
